import { FunctionComponent, useEffect, useState } from 'react'
import { useAuth } from '@/modules/context/AuthContext'
import { RequireAuth } from '@/modules/routes/requireAuth'
import { Role } from '@/types/Role'
import { useLocation } from 'react-router-dom'
import ParentProfile from './parentProfile/parentProfile'
import StaffProfile from './staffProfile/staffProfile'

const AccountProfile: FunctionComponent = () => {
    const { user } = useAuth()

    const paramAccount: URLSearchParams = new URLSearchParams(useLocation().search)

    const [signUp, setSignUp] = useState<boolean>(false)
    const [signUpAutolink, setSignUpAutolink] = useState<boolean>(false)

    useEffect(() => {
        if (paramAccount.get('account') === 'signup') {
            setSignUp(true)
        }
        if (paramAccount.get('account') === 'signupAutolink') {
            setSignUpAutolink(true)
        }
    }, [])

    return (
        <RequireAuth roles={[Role.parent, Role.staff]}>
            <>
                {user && user.role == Role.parent && <ParentProfile signUp={signUp} signUpAutolink={signUpAutolink} />}
                {user && user.role == Role.staff && <StaffProfile signUp={signUp} signUpAutolink={signUpAutolink} />}
            </>
        </RequireAuth>
    )
}

export default AccountProfile
